const firebaseConfig = {
  apiKey: "AIzaSyA8mCNdtdtoTcpFhfNOs_8ILddU2b8phEU",
  authDomain: "d-street-cdff3.firebaseapp.com",
  projectId: "d-street-cdff3",
  storageBucket: "d-street-cdff3.appspot.com",
  messagingSenderId: "599333193815",
  appId: "1:599333193815:web:62d58b02bac2c52ebb3b12"
};
export default firebaseConfig;
